"use strict";
import angular from "angular";
import tritonTimeTargetingHtmlUrl from "./views/tritonTimeTargeting.html";

let app = angular.module("app.tritonTimeTargeting.component", []);

app.component("tritonTimeTargeting", {
  bindings: {
    showActions: "=",
    clusterId: "=",
    model: "=",
    selectedTritonTimeTargeting: "=",
  },
  templateUrl: tritonTimeTargetingHtmlUrl,

  controller: function ($scope) {
    var self = this;
    self.isMainDialogOpen = false;
    self.isHourOfDayDialogOpen = false;
    self.isDayOfWeekDialogOpen = false;
    self.hourOfDayRule = "is";
    self.hourOfDayValue = "";
    self.hourOfDayValueLower = "";
    self.hourOfDayValueUpper = "";
    self.hourOfDayError = "";
    self.hourOfDayChips = [];
    self.tempHourOfDayChips = [];
    self.matchType = true;
    self.isSummaryView = false;
    self.selectedDayOfWeek = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    };
    self.dayOfWeekChips = [];
    self.tempDayOfWeekChips = [];
    self.summaryOrder = [];
    self.hours = [];
    const dayMapping = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7,
    };

    // Dialog controls
    self.openMainDialog = () => (self.isMainDialogOpen = true);
    self.closeMainDialog = () => (self.isMainDialogOpen = false);

    self.openHourOfDayDialog = () => {
      self.isHourOfDayDialogOpen = true;
      self.isMainDialogOpen = false;
      if (self.tempHourOfDayChips.length > 0) {
        self.matchType = self.tempHourOfDayChips[0].match;
      } else {
        self.matchType = true;
      }
      self.tempHourOfDayChips = angular.copy(self.hourOfDayChips);
    };

    self.closeHourOfDayDialog = () => {
      self.resetHourOfDayValues();
      self.isHourOfDayDialogOpen = false;
      if (self.summaryOrder.includes("hourOfDay")) {
        self.isSummaryView = true;
      } else {
        self.hourOfDayChips = [];
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.closeDayOfWeekDialog = () => {
      if (self.tempDayOfWeekChips) {
        Object.keys(self.selectedDayOfWeek).forEach((day) => {
          self.selectedDayOfWeek[day] = false;
        });
      }

      self.isDayOfWeekDialogOpen = false;

      if (self.summaryOrder.includes("dayOfWeek")) {
        self.isSummaryView = true;
      } else {
        self.dayOfWeekChips = [];
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.closeDialog = function (dialogType) {
      if (dialogType === "hourOfDay") {
        self.closeHourOfDayDialog();
        self.tempHourOfDayChips = angular.copy(self.hourOfDayChips);
      }
      if (dialogType === "dayOfWeek") {
        self.closeDayOfWeekDialog();
        if (self.tempDayOfWeekChips) {
          Object.keys(self.selectedDayOfWeek).forEach((day) => {
            self.selectedDayOfWeek[day] = false;
          });
        }
        self.tempDayOfWeekChips = angular.copy(self.dayOfWeekChips);
      }
    };

    ["hourOfDayChips", "dayOfWeekChips"].forEach((chipType) => {
      $scope.$watch(
        chipType,
        function () {
          if (!self.hourOfDayChips.length && !self.dayOfWeekChips.length) {
            self.summaryOrder = [];
          }
        },
        true
      );
    });

    self.goBackToMain = () => {
      self.isHourOfDayDialogOpen = false;
      self.isMainDialogOpen = true;
      self.isDayOfWeekDialogOpen = false;
    };

    self.closeAllDialogs = () => {
      self.isMainDialogOpen = false;
      self.isHourOfDayDialogOpen = false;
    };

    // Reset hourOfDay input values
    self.resetHourOfDayValues = () => {
      self.hourOfDayValue = "";
      self.hourOfDayValueLower = "";
      self.hourOfDayValueUpper = "";
      self.hourOfDayError = "";
    };

    self.addHourOfDay = () => {
      if (self.hourOfDayRule === "between") {
        if (!self.hourOfDayValueLower || !self.hourOfDayValueUpper) {
          self.hourOfDayError = "Both lower and upper limits are required.";
          return;
        }

        const lowerHourObj = self.hours.find(
          (hour) => hour.value == self.hourOfDayValueLower
        );
        const upperHourObj = self.hours.find(
          (hour) => hour.value == self.hourOfDayValueUpper
        );

        if (!lowerHourObj || !upperHourObj) {
          self.hourOfDayError = "Invalid time selection.";
          return;
        }

        const lowerValue = lowerHourObj.value; // Numeric 24-hour value
        const upperValue = upperHourObj.value; // Numeric 24-hour value

        if (lowerValue >= upperValue) {
          self.hourOfDayError =
            "Invalid range. Ensure lower limit is less than upper limit.";
          return;
        }

        // Format display values correctly
        const lowerDisplay = lowerHourObj.label.split(" / ")[1]; // "12:00 am"
        const upperDisplay = upperHourObj.label.split(" / ")[1]; // "2:00 pm"

        const range = `${lowerDisplay} - ${upperDisplay}`;

        if (
          self.tempHourOfDayChips.some(
            (chip) => chip.value === range && chip.match === self.matchType
          )
        ) {
          self.hourOfDayError = "Duplicate range is not allowed.";
          return;
        }

        self.tempHourOfDayChips.push({
          value: range,
          match: self.matchType,
          rule: "between",
        });
      } else {
        if (!self.hourOfDayValue) {
          self.hourOfDayError = "Hour value is required.";
          return;
        }

        // Extract the value before the slash "00:00 / 12:00 am" -> "00:00"
        const selectedHourObj = self.hours.find(
          (hour) => hour.value == self.hourOfDayValue
        );
        const displayValue = selectedHourObj
          ? selectedHourObj.label.split(" / ")[0]
          : "";

        if (!displayValue) {
          self.hourOfDayError = "Invalid hour value.";
          return;
        }

        if (
          self.tempHourOfDayChips.some(
            (chip) =>
              chip.value === displayValue && chip.match === self.matchType
          )
        ) {
          self.hourOfDayError = "Duplicate hour value is not allowed.";
          return;
        }

        self.tempHourOfDayChips.push({
          value: displayValue, // Store "12:00 am" instead of "00:00 / 12:00 am"
          match: self.matchType,
          rule: self.hourOfDayRule,
        });
      }
    };

    self.removeChip = (index, type) => {
      if (type === "dayOfWeek" && self.tempDayOfWeekChips[index]) {
        const chip = self.tempDayOfWeekChips[index];
        const dayKey = chip.value.toLowerCase();

        if (self.selectedDayOfWeek.hasOwnProperty(dayKey)) {
          self.selectedDayOfWeek[dayKey] = false;
        }

        self.tempDayOfWeekChips.splice(index, 1);

        self.selectedDayOfWeek.all_days = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ].every((day) => self.selectedDayOfWeek[day]);
      } else if (type === "hourOfDay" && self.tempHourOfDayChips[index]) {
        self.tempHourOfDayChips.splice(index, 1);
      }
    };

    self.clearHourOfDayChips = () => {
      self.tempHourOfDayChips = [];

      if (self.summaryOrder.includes("hourOfDay")) {
        self.isSummaryView = true;
      } else {
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.clearDayOfWeekChips = () => {
      self.tempDayOfWeekChips = [];
      self.selectedDayOfWeek = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      };
      self.selectedDayOfWeek.monday = false;
      self.selectedDayOfWeek.tuesday = false;
      self.selectedDayOfWeek.wednesday = false;
      self.selectedDayOfWeek.thursday = false;
      self.selectedDayOfWeek.friday = false;
      self.selectedDayOfWeek.saturday = false;
      self.selectedDayOfWeek.sunday = false;

      if (self.summaryOrder.includes("dayOfWeek")) {
        self.isSummaryView = true;
      } else {
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.setMatch = (type) => {
      self.matchType = type;
      self.tempHourOfDayChips = self.tempHourOfDayChips.map((chip) => ({
        ...chip,
        match: type,
      }));
    };

    self.setDayOfWeekMatch = (type) => {
      self.matchType = type;
      self.tempDayOfWeekChips = self.tempDayOfWeekChips.map((chip) => ({
        ...chip,
        match: type,
      }));
    };

    // Chip text formatting
    self.getFormattedChipText = (chip, key) => {
      if (key === "dayOfWeek") {
        return chip.value;
      }

      if (key === "hourOfDay") {
        switch (chip.rule) {
          case "is":
            return chip.value;
          case "onOrBefore":
            return `<= ${chip.value}`;
          case "onOrAfter":
            return `>= ${chip.value}`;
          case "between":
            const values = chip.value.split("-");
            return `${values[0]} - ${values[1]}`;
          default:
            return chip.value;
        }
      }

      return chip.value;
    };

    self.addHourOfDayRule = function () {
      if (self.tempHourOfDayChips.length > 0) {
        self.hourOfDayChips = angular.copy(self.tempHourOfDayChips);
      }

      if (self.hourOfDayChips.length > 0) {
        const hasNegativeMatch = self.hourOfDayChips.some(
          (chip) => chip.match === false
        );

        const processedHourOfDayRules = self.hourOfDayChips
          .map((chip) => {
            const hourOnly = parseInt(chip.value.split(":")[0], 10); // Convert to number (00 -> 0, 01 -> 1)

            switch (chip.rule) {
              case "is":
                return {
                  dimension: "hour",
                  type: "equals",
                  value: hourOnly.toString(),
                };
              case "between":
                const [lower, upper] = chip.value
                  .split("-")
                  .map((time) => parseInt(time.split(":")[0], 10));
                return {
                  dimension: "hour",
                  type: "bound",
                  lower: lower,
                  upper: upper,
                };
              case "onOrBefore":
                return {
                  dimension: "hour",
                  type: "bound",
                  upper: hourOnly,
                };
              case "onOrAfter":
                return {
                  dimension: "hour",
                  type: "bound",
                  lower: hourOnly,
                };
              default:
                return null;
            }
          })
          .filter(Boolean);

        if (!self.summaryOrder.includes("hourOfDay")) {
          self.summaryOrder.push("hourOfDay");
        }

        if (
          self.selectedTritonTimeTargeting &&
          self.selectedTritonTimeTargeting.rules &&
          self.selectedTritonTimeTargeting.rules.fields
        ) {
          self.selectedTritonTimeTargeting.rules.fields = cleanRules(
            self.selectedTritonTimeTargeting.rules.fields
          );
        }

        function cleanRules(fields) {
          return fields.filter((rule) => {
            if (rule.dimension === "hour") {
              return false;
            }

            if (rule.type === "not" && rule.field) {
              rule.field.fields = cleanRules(rule.field.fields || []);
              if (!rule.field.fields.length) {
                return false;
              }
            }

            if (rule.fields && rule.fields.length > 0) {
              rule.fields = cleanRules(rule.fields);
            }

            return !(rule.fields && rule.fields.length === 0);
          });
        }

        self.updateTargetingPayload(
          "hourOfDay",
          processedHourOfDayRules,
          hasNegativeMatch
        );

        // Close the dialog and update the view
        self.isHourOfDayDialogOpen = false;
        self.isSummaryView = true;
      }
    };

    self.updateTargetingPayload = function (
      ruleType,
      ruleData,
      hasNegativeMatch
    ) {
      // Initialize targeting payload if not already present
      if (
        !self.selectedTritonTimeTargeting ||
        Object.keys(self.selectedTritonTimeTargeting).length === 0
      ) {
        self.selectedTritonTimeTargeting = {
          targeting_type: "time",
          rules: {
            type: "or",
            fields: [
              {
                type: "and",
                fields: [],
              },
            ],
          },
        };
      }

      if (!ruleData || ruleData.length === 0) {
        // Do not proceed if there's no ruleData to add
        return;
      }

      // Create a new rule based on ruleType
      let newRule;
      if (ruleType === "hourOfDay") {
        const hourOfDayRule = {
          type: "or",
          fields: ruleData,
        };

        if (hasNegativeMatch) {
          newRule = {
            type: "and",
            fields: [
              {
                type: "not",
                field: hourOfDayRule,
              },
            ],
          };
        } else {
          newRule = {
            type: "and",
            fields: [hourOfDayRule],
          };
        }
      } else if (ruleType === "dayOfWeek") {
        if (hasNegativeMatch) {
          newRule = {
            type: "and",
            fields: [
              {
                type: "not",
                field: ruleData,
              },
            ],
          };
        } else {
          newRule = {
            type: "and",
            fields: [ruleData],
          };
        }
      }

      const andBlock = self.selectedTritonTimeTargeting.rules.fields.find(
        (rule) => rule.type === "and"
      );

      if (andBlock) {
        if (newRule && newRule.fields.length > 0) {
          andBlock.fields.push(newRule);
        }
      } else {
        if (newRule && newRule.fields.length > 0) {
          self.selectedTritonTimeTargeting.rules.fields.push({
            type: "and",
            fields: [newRule],
          });
        }
      }
    };

    self.addHourOfDayRuleAndContinue = () => {
      self.addHourOfDayRule();
      self.closeHourOfDayDialog();
      self.goBackToMain();
    };

    self.addDayOfWeekRuleAndContinue = () => {
      self.addDayOfWeekRule();
      self.closeDayOfWeekDialog();
      self.goBackToMain();
    };

    // Watch for changes in hourOfDayRule to reset values if needed
    $scope.$watch("hourOfDayRule", (newRule) => {
      if (newRule === "between") {
        self.resetHourOfDayValues();
      } else {
        self.hourOfDayValueLower = "";
        self.hourOfDayValueUpper = "";
      }
    });

    self.showSummaryView = () => {
      self.isSummaryView = true;
      self.isMainDialogOpen = false;
      self.isHourOfDayDialogOpen = false;
    };

    self.cancelKey = function (key) {
      if (key === "hourOfDay") {
        // Clear hourOfDay chips and remove hourOfDay rule
        self.hourOfDayChips = [];
        self.selectedTritonTimeTargeting.rules.fields =
          self.selectedTritonTimeTargeting.rules.fields
            .map((rule) => {
              // Remove only the 'hourOfDay' fields while keeping the rest intact
              if (rule.fields) {
                rule.fields = rule.fields.filter(
                  (field) => !containsDimension(field, "hourOfDay")
                );
              }
              return rule;
            })
            .filter((rule) => rule.fields.length > 0); // Remove empty rules
      } else if (key === "dayOfWeek") {
        // Clear dayOfWeek chips and remove dayOfWeek rule
        self.dayOfWeekChips = [];
        self.selectedDayOfWeek = {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        };
        self.selectedDayOfWeek.monday = false;
        self.selectedDayOfWeek.tuesday = false;
        self.selectedDayOfWeek.wednesday = false;
        self.selectedDayOfWeek.thursday = false;
        self.selectedDayOfWeek.friday = false;
        self.selectedDayOfWeek.saturday = false;
        self.selectedDayOfWeek.sunday = false;
        self.selectedTritonTimeTargeting.rules.fields =
          self.selectedTritonTimeTargeting.rules.fields
            .map((rule) => {
              // Remove only the 'dayOfWeek' fields while keeping the rest intact
              if (rule.fields) {
                rule.fields = rule.fields.filter(
                  (field) => !containsDimension(field, "day-of-week")
                );
              }
              return rule;
            })
            .filter((rule) => rule.fields.length > 0); // Remove empty rules
      }

      // Remove the key from summaryOrder
      const keyIndex = self.summaryOrder.indexOf(key);
      if (keyIndex > -1) {
        self.summaryOrder.splice(keyIndex, 1);
      }

      // Update the UI to reflect the changes
      self.isSummaryView =
        self.hourOfDayChips.length > 0 || self.dayOfWeekChips.length > 0;
    };

    // Helper function to check for a dimension in a rule
    function containsDimension(rule, dimension) {
      if (rule.dimension === dimension) {
        return true;
      }
      if (rule.fields) {
        return rule.fields.some((field) => containsDimension(field, dimension));
      }
      return false;
    }

    // dayOfWeek
    self.openDayOfWeekDialog = () => {
      self.isDayOfWeekDialogOpen = true;
      self.isMainDialogOpen = false;
      if (self.tempDayOfWeekChips.length > 0) {
        self.matchType = self.tempDayOfWeekChips[0].match;
      } else {
        self.matchType = true;
      }
      self.tempDayOfWeekChips = angular.copy(self.dayOfWeekChips);
      self.dayOfWeekChips.forEach((chip) => {
        const dayOfWeekKey = chip.value.toLowerCase();
        self.selectedDayOfWeek[dayOfWeekKey] = true;
      });
    };

    // Add dayOfWeek Rule
    self.addDayOfWeekRule = function () {
      if (self.tempDayOfWeekChips && self.tempDayOfWeekChips.length > 0) {
        self.dayOfWeekChips = angular.copy(self.tempDayOfWeekChips);
      }

      if (!self.summaryOrder.includes("dayOfWeek")) {
        self.summaryOrder.push("dayOfWeek");
      }

      const selectedDayOfWeekValues = Object.keys(self.selectedDayOfWeek)
        .filter(
          (day) => self.selectedDayOfWeek[day] && dayMapping[day] !== undefined
        )
        .map((day) => String(dayMapping[day]));

      const allDaysSelected = selectedDayOfWeekValues.length === 7; // Check if all days are selected

      const hasNegativeMatch = self.dayOfWeekChips.some(
        (chip) => chip.match === false
      );

      function removeDayOfWeekRules(fields) {
        return fields.filter((rule) => {
          if (rule.fields) {
            rule.fields = removeDayOfWeekRules(rule.fields);
          }
          return !(rule.dimension === "day-of-week");
        });
      }

      if (
        self.selectedTritonTimeTargeting &&
        self.selectedTritonTimeTargeting.rules &&
        self.selectedTritonTimeTargeting.rules.fields
      ) {
        self.selectedTritonTimeTargeting.rules.fields = removeDayOfWeekRules(
          self.selectedTritonTimeTargeting.rules.fields
        );
      }

      if (selectedDayOfWeekValues.length > 0) {
        let rule;
        if (allDaysSelected) {
          // If all days are selected, use a "bound" type rule
          rule = {
            type: "bound",
            dimension: "day-of-week",
            lower: 1,
            upper: 7,
          };
        } else {
          // If only specific days are selected, use "in" type rule
          rule = {
            type: "in",
            dimension: "day-of-week",
            values: selectedDayOfWeekValues,
          };
        }

        // Pass the final rule to updateTargetingPayload
        self.updateTargetingPayload("dayOfWeek", rule, hasNegativeMatch);
      }

      self.selectedTritonTimeTargeting.rules = self.removeEmptyAndBlocks(
        self.selectedTritonTimeTargeting.rules
      );

      self.closeDayOfWeekDialog();
      self.isSummaryView = true;
    };

    self.toggleDayOfWeek = function (dayOfWeek) {
      if (dayOfWeek === "all_days") {
        const selectAll = self.selectedDayOfWeek.all_days;
        [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ].forEach((day) => (self.selectedDayOfWeek[day] = selectAll));

        self.tempDayOfWeekChips = selectAll
          ? [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ].map((day) => ({ value: day, match: self.matchType }))
          : [];
      } else {
        const index = self.tempDayOfWeekChips.findIndex(
          (chip) => chip.value.toLowerCase() === dayOfWeek
        );
        self.selectedDayOfWeek[dayOfWeek]
          ? index === -1 &&
            self.tempDayOfWeekChips.push({
              value: dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1),
              match: self.matchType,
            })
          : index !== -1 && self.tempDayOfWeekChips.splice(index, 1);

        self.selectedDayOfWeek.all_days = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ].every((day) => self.selectedDayOfWeek[day]);
      }
    };

    self.deleteSet = () => {
      self.hourOfDayChips = [];
      self.dayOfWeekChips = [];
      self.isSummaryView = false;
      self.selectedTritonTimeTargeting = [];
      self.selectedDayOfWeek = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      };
      self.selectedDayOfWeek.monday = false;
      self.selectedDayOfWeek.tuesday = false;
      self.selectedDayOfWeek.wednesday = false;
      self.selectedDayOfWeek.thursday = false;
      self.selectedDayOfWeek.friday = false;
      self.selectedDayOfWeek.saturday = false;
      self.selectedDayOfWeek.sunday = false;
    };

    self.formatHour = function (hour) {
      return hour !== undefined ? `${hour.toString().padStart(2, "0")}:00` : "";
    };

    self.initializeChips = function () {
      self.hourOfDayChips = [];
      self.dayOfWeekChips = [];

      let parsedSets;
      try {
        parsedSets = self.selectedTritonTimeTargeting;
      } catch (e) {
        return;
      }

      if (!parsedSets.rules || !parsedSets.rules.fields) {
        return;
      }

      parsedSets.rules.fields.forEach(function (rule) {
        if (rule.type === "and") {
          rule.fields.forEach(function (innerRule) {
            if (innerRule.type === "and") {
              innerRule.fields.forEach(function (innerMostRule) {
                let selectedDays = [];
                let allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                let matchType = true;

                // Handling NOT scenario for day-of-week
                if (innerMostRule.type === "not" && innerMostRule.field && innerMostRule.field.dimension === "day-of-week") {
                  innerMostRule = innerMostRule.field;
                  matchType = false;
                }

                if (innerMostRule.dimension === "day-of-week") {
                  if (Array.isArray(innerMostRule.values) && innerMostRule.values.length > 0) {
                    selectedDays = innerMostRule.values.map((value) => allDays[value - 1]);
                  } else if (innerMostRule.lower !== undefined && innerMostRule.upper !== undefined) {
                    if (innerMostRule.lower === 1 && innerMostRule.upper === 7) {
                      selectedDays = [...allDays];
                    } else {
                      selectedDays = allDays.slice(innerMostRule.lower - 1, innerMostRule.upper);
                    }
                  }

                  self.selectedDayOfWeek = {
                    all_days: selectedDays.length === allDays.length,
                    monday: selectedDays.includes("Monday"),
                    tuesday: selectedDays.includes("Tuesday"),
                    wednesday: selectedDays.includes("Wednesday"),
                    thursday: selectedDays.includes("Thursday"),
                    friday: selectedDays.includes("Friday"),
                    saturday: selectedDays.includes("Saturday"),
                    sunday: selectedDays.includes("Sunday"),
                  };

                  self.tempDayOfWeekChips = selectedDays.map((day) => ({
                    value: day,
                    match: matchType,
                  }));

                  self.dayOfWeekChips = angular.copy(self.tempDayOfWeekChips);

                  if (!self.summaryOrder.includes("dayOfWeek")) {
                    self.summaryOrder.push("dayOfWeek");
                  }
                }

                // Handling NOT scenario for hourOfDay
                if (innerMostRule.type === "not" && innerMostRule.field) {
                  if (innerMostRule.field.type === "or" && innerMostRule.field.fields) {
                    innerMostRule.field.fields.forEach(function (field) {
                      processHourField(field, false);
                    });
                  } else {
                    processHourField(innerMostRule.field, false);
                  }
                }

                if (innerMostRule.type === "or" && innerMostRule.fields) {
                  innerMostRule.fields.forEach(function (field) {
                    processHourField(field, true);
                  });
                }
              });
            }
          });
        }
      });

      function processHourField(field, matchType) {
        if (field.dimension === "hour") {
          let chipValue = "";
          let rule = "";

          if (field.type === "equals") {
            chipValue = self.formatHour(field.value);
            rule = "is";
          } else if (field.type === "bound") {
            if (field.lower !== undefined && field.upper !== undefined) {
              chipValue = `${self.formatHour(field.lower)} - ${self.formatHour(field.upper)}`;
              rule = "between";
            } else if (field.lower !== undefined) {
              chipValue = self.formatHour(field.lower);
              rule = "onOrAfter";
            } else if (field.upper !== undefined) {
              chipValue = self.formatHour(field.upper);
              rule = "onOrBefore";
            }
          }

          self.hourOfDayChips.push({
            value: chipValue,
            match: matchType,
            rule: rule,
          });

          self.tempHourOfDayChips.push({
            value: chipValue,
            match: matchType,
            rule: rule,
          });

          if (!self.summaryOrder.includes("hourOfDay")) {
            self.summaryOrder.push("hourOfDay");
          }
        }
      }
    };

    self.removeEmptyAndBlocks = function (rules) {
      if (!rules || !Array.isArray(rules.fields)) return rules;

      rules.fields = rules.fields
        .map((rule) => {
          if (rule.fields) {
            rule.fields = self.removeEmptyAndBlocks(rule).fields;
          }
          return rule;
        })
        .filter(
          (rule) =>
            !(
              rule.type === "and" &&
              Array.isArray(rule.fields) &&
              rule.fields.length === 0
            )
        );

      return rules;
    };

    self.initComponent = function () {
      self.hours = [];
      for (let i = 0; i < 24; i++) {
        let ampm = i < 12 ? "am" : "pm";
        let hour12 = i % 12 === 0 ? 12 : i % 12;
        let label = (i < 10 ? "0" + i : i) + ":00 / " + hour12 + ":00 " + ampm;
        self.hours.push({ value: i, label: label });
      }
      if (self.hours && self.hours.length) {
        self.selectedHour = self.hours[0].value;
        self.hourOfDayValueLower = self.hours[0].value;
        self.hourOfDayValueUpper = self.hours[0].value;
      }
      if (
        self.selectedTritonTimeTargeting &&
        self.selectedTritonTimeTargeting.length > 0
      ) {
        self.selectedTritonTimeTargeting = JSON.parse(
          self.selectedTritonTimeTargeting
        );

        if (self.showActions) {
          self.editMode = false;
          self.enableViewMode = true;
          self.isSummaryView = true;
          self.isMainDialogOpen = false;
          self.isHourOfDayDialogOpen = false;
          self.isDayOfWeekDialogOpen = false;
          self.initializeChips();
        } else {
          self.enableViewMode = true;
          self.isSummaryView = true;
          self.isMainDialogOpen = false;
          self.isHourOfDayDialogOpen = false;
          self.isDayOfWeekDialogOpen = false;
          self.initializeChips();
        }
      } else {
        self.enableViewMode = false;
        self.isSummaryView = false;
        self.isMainDialogOpen = false;
        self.isHourOfDayDialogOpen = false;
        self.isDayOfWeekDialogOpen = false;
        self.editMode = false;
        self.selectedTritonTimeTargeting = [];
      }
    };

    self.initComponent();
  },
});
